import { MantineProvider, createTheme } from "@mantine/core"
import { useEffect, useState } from "react"

const fontStack =
  "var(--font-sans), ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif"

const jawnaspoldzielniaColorScale = [
  "color-mix(in srgb, var(--color-action) 8%, var(--color-surface))",
  "color-mix(in srgb, var(--color-action) 14%, var(--color-surface))",
  "color-mix(in srgb, var(--color-action) 22%, var(--color-surface))",
  "color-mix(in srgb, var(--color-action) 34%, var(--color-surface))",
  "color-mix(in srgb, var(--color-action) 48%, var(--color-surface))",
  "var(--color-action-hover)",
  "var(--color-action)",
  "var(--color-action-pressed)",
  "color-mix(in srgb, var(--color-action-pressed) 82%, var(--color-ink))",
  "color-mix(in srgb, var(--color-action-pressed) 68%, var(--color-ink))",
]

const theme = createTheme({
  primaryColor: "jawnaspoldzielnia",
  primaryShade: { light: 6, dark: 6 },
  defaultRadius: "10px",
  fontFamily: fontStack,
  headings: {
    fontFamily: fontStack,
  },
  colors: {
    jawnaspoldzielnia: jawnaspoldzielniaColorScale,
  },
  components: {
    ActionIcon: {
      defaultProps: {
        radius: "10px",
      },
    },
    Button: {
      defaultProps: {
        radius: "10px",
      },
      styles: {
        root: {
          fontWeight: 600,
          minHeight: "40px",
        },
      },
    },
    Input: {
      defaultProps: {
        radius: "10px",
      },
      styles: {
        input: {
          backgroundColor: "var(--color-form-control-bg)",
          borderColor: "var(--color-line)",
          color: "var(--color-ink)",
          fontWeight: 500,
        },
      },
    },
    InputWrapper: {
      styles: {
        label: {
          color: "var(--color-ink-soft)",
          fontWeight: 650,
        },
      },
    },
    PasswordInput: {
      defaultProps: {
        radius: "10px",
      },
    },
  },
})

export default function MantineThemeProvider({ children }) {
  const [colorScheme, setColorScheme] = useState(resolveColorScheme)

  useEffect(() => {
    const root = document.documentElement
    const observer = new MutationObserver(() => setColorScheme(resolveColorScheme()))

    observer.observe(root, { attributes: true, attributeFilter: ["data-theme"] })
    setColorScheme(resolveColorScheme())

    return () => observer.disconnect()
  }, [])

  return (
    <MantineProvider theme={theme} forceColorScheme={colorScheme}>
      {children}
    </MantineProvider>
  )
}

function resolveColorScheme() {
  if (typeof document === "undefined") return "light"

  return document.documentElement.dataset.theme === "dark" ? "dark" : "light"
}
